unit Simple.Dashboard.Bulk.Types;

interface

uses
  Simple.Dashboard.Return.Types {$IFDEF PAS2JS}, JS{$ENDIF};

type
  TDashboardBulkItem = class
  public
    ItemId: Integer;
    Response: TDashboardResponse;
{$IFDEF PAS2JS}
    Constructor Create(Value: JS.TJSObject);
    Procedure Assign(Value: JS.TJSObject);
{$ENDIF}
  end;

implementation

{$IFDEF PAS2JS}
Constructor TDashboardBulkItem.Create(Value: JS.TJSObject);
begin
  inherited Create;
  Assign(Value);
end;

Procedure TDashboardBulkItem.Assign(Value: JS.TJSObject);
var
  lResponseObj: TJSObject;
  lResponseText: string;
begin
  ItemId := integer(TJSObject(Value)['ItemId']);
  if ItemId = 0 then
    ItemId := integer(TJSObject(Value)['itemId']);
  Response := TDashboardResponse.Create;
  lResponseText := '';
  lResponseObj := nil;

  if JS.isString(TJSObject(Value)['Response']) then
    lResponseText := string(TJSObject(Value)['Response'])
  else if JS.isString(TJSObject(Value)['response']) then
    lResponseText := string(TJSObject(Value)['response'])
  else if TJSObject(Value)['Response'] <> nil then
    lResponseObj := TJSObject(TJSObject(Value)['Response'])
  else if TJSObject(Value)['response'] <> nil then
    lResponseObj := TJSObject(TJSObject(Value)['response']);

  if lResponseText <> '' then
    lResponseObj := JS.toObject(TJSJSON.parse(lResponseText));

  if lResponseObj <> nil then
    Response.Assign(UnwrapXDataResultObject(lResponseObj));
end;
{$ENDIF}

end.
